import(/* webpackMode: "eager", webpackExports: ["logClickstreamEvent"] */ "/builds/idp-education/idp-connect/he-websites/next-js/he-websites/packages/lib/utlils/clickstream.tsx");
;
import(/* webpackMode: "eager" */ "/builds/idp-education/idp-connect/he-websites/next-js/he-websites/packages/lib/utlils/helper-function.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/idp-education/idp-connect/he-websites/next-js/he-websites/packages/shared-components/university-course-reviews/university-course-reviews.tsx");
